import { getBearerToken } from '@sylveraio/auth-utils'
import { HUXLEY_API_HEADERS } from '@sylveraio/constants'

/**
 * @deprecated - use the generated client functions instead
 */
export async function fetchAuthenticated<T = unknown>(
  endpoint: string,
  method: 'GET' | 'POST' | 'PATCH' = 'GET',
  bodyObject?: Record<string, unknown>,
): Promise<T> {
  const bearerToken = await getBearerToken()
  const body = bodyObject ? JSON.stringify(bodyObject) : undefined
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_MONARCH_API_URL}${endpoint}`,
    {
      method,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        ...HUXLEY_API_HEADERS,
      },
      body,
    },
  )

  if (response.status === 403) {
    throw new Error('UNAUTHORIZED')
  }

  return response.json() as Promise<T>
}
